import classNames from "classnames";

import {AssistantIcon} from "@/components/assistant/AssistantIcon.tsx";
import {AnalyzerChatMessageProps} from "@/pages/analyzer/Analyzer.types.ts";
import {hasMarkdown} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerMarkdown} from "@/pages/analyzer/components/AnalyzerMarkdown.tsx";

import styles from "./AnalyzerChatMessage.module.scss";

export const AnalyzerChatMessage = ({content, className}: AnalyzerChatMessageProps) => (
  <div className={classNames(styles.message, className)}>
    <AssistantIcon size="small" className={styles.avatar} />
    <div className={styles.bubble}>
      {hasMarkdown(content) ? <AnalyzerMarkdown content={content} /> : <span>{content}</span>}
    </div>
  </div>
);
